import { useState, useEffect } from "react";
import { projectFirestoreDB } from "../firebase/config";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";

const useFirestore = (collection2) => {
  const [docs, setDocs] = useState([]);

  // useEffect hook, for listening to changes in the DB
  useEffect(() => {
    const querySnapshot = query(collection2, orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(querySnapshot, (snap) => {
      const allMemes = [];
      snap.forEach((doc) => {
        allMemes.push({ ...doc.data(), id: doc.id });
      });
      setDocs(allMemes);
    });

    //unsubscribe();
    // this is a cleanup function that react will run when
    // a component using the hook unmounts
    // this for some reason made it so the site continously fetched data and this is the reason for the high reads
  }, [collection2]);

  return { docs };
};

export default useFirestore;
